<template>
    <div>
        <el-drawer title="批量操作" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
            @close="close">
            <div class="drawer-content">
                <div>
                    <el-radio-group v-model="type" size="medium">
                        <el-radio :label="1" border>批量发货</el-radio>
                       <!-- <el-radio :label="2" border>批量待退款</el-radio>
                        <el-radio :label="3" border>批量已退款</el-radio> -->
                    </el-radio-group>
                </div>
                <div class="MT20">
                    <el-upload drag action :http-request="uploadExcel" :auto-upload="false" ref="upload"
                        accept=".xls, .xlsx" :show-file-list="true" :before-upload="beforeUpload" :file-list="fileList"
                        :on-change="onChange" :on-remove="onRemove" :disabled="uploadLoading">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
                        <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，单次最多处理10000个订单</div>
                    </el-upload>
                </div>

                <div class="color-info">
                    导入文件示例如下:
                    <el-button v-if="$utils.have('/goodOrder/downloadTemp')" type="text" icon="el-icon-download"
                        @click="download">
                        点击下载模板
                    </el-button>
                </div>

                <div class="temp-table">
                    <el-table v-if="type != 1" :data="tempModel2" style="width: 100%" size="small" border>
                        <el-table-column prop="orderSn" label="订单编号"></el-table-column>
                        <el-table-column prop="money" label="实际支付金额(不含运费)"></el-table-column>
                    </el-table>
                    <el-table v-else :data="tempModel1" style="width: 100%" size="small" border>
                        <el-table-column prop="orderSn" label="订单编号"></el-table-column>
                        <el-table-column prop="expressId" label="快递公司"></el-table-column>
                        <el-table-column prop="expressNo" label="运单号"></el-table-column>
                    </el-table>
                </div>

                <div class="from-tip color-danger">
                    <p v-if="type == 1">支持修改已发货订单的快递信息</p>
                    <p v-if="type == 2">仅支持未发起过退款的订单</p>
                    <p v-if="type == 3">仅支持全部商品均为待退款的订单</p>
                </div>
            </div>
            <div class="drawer-footer">
                <el-button @click="close">取消</el-button>
                <el-button type="primary" @click="onSubmit" :loading="btnLoading" :disabled="canSubmit">提交</el-button>
            </div>

            <ErrorMsg ref="errorMsg"></ErrorMsg>

        </el-drawer>
    </div>
</template>

<script>
import { downloadFileTmp, uploadFileTmp } from '@/assets/js/commonApi.js';
import ErrorMsg from './ErrorMsg';
export default {
    props: {
        id: {
            type: [Number, String],
            default: '',
        },
    },
    components: { ErrorMsg },
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            downLoading: false,
            uploadLoading: false,
            tempModel1: [{
                orderSn: 'xdyc000000000001',
                expressId: '顺丰',
                expressNo: '000000000000001'
            }, {
                orderSn: 'xdyc000000000002',
                expressId: '网络发送',
                expressNo: '网络发送'
            }],
            tempModel2: [{
                orderSn: 'xdyc000000000001',
                money: '20',
            }, {
                orderSn: 'xdyc000000000002',
                money: '30',
            }],
            canSubmit: true,
            fileList: [],
            // errMsgShow:false,
            // errMsgList:[],
            type: 1, //1.周边批量发货 2.批量待退款 3.批量已退款
        }
    },
    methods: {
        show() {
            this.drawerShow = true;

        },
        close() {
            this.fileList = [];
            this.$refs.upload.clearFiles();
            this.drawerShow = false;
        },
        //下载模板
        async download() {
            let filePath;
            this.downLoading = true;
            const res = await this.$request({
                url: '/goodOrder/downloadTemp',
                method: 'post',
                params: { type: this.type }
            })
                .catch(err => {
                    this.$message({ message: err.message, type: 'error' });
                })
            const { state, msg, result: { url } } = res.data;
            if (state == 1 && url) {
                filePath = url;
            } else {
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }
            const _fileName = this.type == 1 ? '周边批量发货模板' : this.type == 2 ? '周边批量待退款模板' : '周边批量已退款模板';
            await downloadFileTmp(filePath, _fileName + '.' + this.$utils.getFileType(filePath));
            this.downLoading = false;
        },
        onSubmit() {
            this.$refs.upload.submit();
        },
        async uploadExcel(req) {
            this.btnLoading = true;
            this.uploadLoading = true;
            const formData = new FormData();
            formData.append('file', req.file);

            let filePath;
            const res = await uploadFileTmp(formData).catch(err => {
                this.$message({ message: err.message, type: 'error' });
            }).finally(() => {
                this.uploadLoading = false;
            });
            const { state, msg, result } = res.data;
            if (state == 1 && result) {
                filePath = result.url;
            } else {
                this.$message.error(msg || '上传失败');
            }

            this.$request({
                url: '/goodOrder/batchImport',
                method: 'post',
                params: { path: filePath, type: this.type }
            })
                .then(res => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        if (result && (
                                result.insufficientBalanceOrder && result.insufficientBalanceOrder.length > 0 || 
                                result.lockingOrder && result.lockingOrder.length > 0 || 
                                result.reconciliationFailedOrder && result.reconciliationFailedOrder.length > 0
                            )
                        ){
                            // this.errMsgShow = true;
                            //this.errMsgList = result;
                            this.$refs.errorMsg.show(result);
                        } else {
                            this.onSuccess();
                        }

                    } else {
                        this.$message.error(msg || '上传失败');
                        this.canSubmit = false;
                    }
                })
                .catch(err => {
                    this.canSubmit = false;
                    this.$message({ message: err.message, type: 'error' });
                })
                .finally(() => {
                    this.btnLoading = false;
                    this.canSubmit = true;
                });
        },
        beforeUpload(file) {
            const type = this.$utils.getFileType(file.name)
            const isType = type === 'xls' || type === 'xlsx';
            if (!isType) {
                this.$message.error('仅支持xls、xlsx文件格式,请重新选择上传文件!');
            }
            return isType;
        },
        onSuccess() {
            this.$emit('onUpdate');
            this.close();
        },
        onChange(file) {
            if (file) {
                this.fileList = [{ ...file }]
                this.canSubmit = false;
            } else {
                this.canSubmit = true;
            }
        },
        onRemove() {
            this.canSubmit = true;
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger,
::v-deep .el-upload {
    width: 100%;
}

.color-info {
    margin-top: 20px;
}

.el-table {
    margin-bottom: 10px;
}

.from-tip {
    max-width: 420px;
    font-size: 12px;

    b {
        color: $--color-theme;
    }
}
</style>